import { EntityAvatar } from '@/modules/common';

import {
  getApprovalActionTotals,
  getSelectedMemberCounts,
} from '../../../helpers/approval-selection-counts.helper';
import { formatHours } from '../../../helpers/format-time-track.helper';
import {
  ApprovalConfirmMode,
  ApprovalSelectedMember,
} from '../../../types/time-tracking-approvals';
import {
  ApprovalConfirmCard,
  ApprovalConfirmCardHeader,
  ApprovedHoursSplitRows,
  ProjectMetaRow,
  TranslateFn,
} from './approval-confirm-card';

interface SelectedMemberCardProps {
  selectedMember: ApprovalSelectedMember;
  mode: ApprovalConfirmMode;
  dateRange: string;
  ns: string;
  t: TranslateFn;
}

/**
 * Card for a team member selected via their row checkbox (member-level approval).
 * Shows what the ACTION covers: approved hours (split invoice / bill) and entries to approve
 * (pending) or to unapprove (approved), net of any exclusions the user unchecked underneath.
 */
export function SelectedMemberCard({
  selectedMember,
  mode,
  dateRange,
  ns,
  t,
}: SelectedMemberCardProps) {
  const { member, projectName } = selectedMember;
  const { count: actionCount, hours: actionHours } = getApprovalActionTotals(
    getSelectedMemberCounts(selectedMember),
    mode
  );

  return (
    <ApprovalConfirmCard>
      <ApprovalConfirmCardHeader
        marker={
          <EntityAvatar image={member.member.avatarUrl} name={member.member.name} size="xs" />
        }
        name={member.member.name}
      />
      <div className="flex flex-col gap-1.5">
        <ProjectMetaRow label={t(`${ns}.projectCard.project` as Parameters<typeof t>[0])}>
          {projectName}
        </ProjectMetaRow>
        <ProjectMetaRow label={t(`${ns}.projectCard.dateRange` as Parameters<typeof t>[0])}>
          {dateRange}
        </ProjectMetaRow>
        <ProjectMetaRow label={t(`${ns}.projectCard.totalHours` as Parameters<typeof t>[0])}>
          {formatHours(member.trackedHours)}
        </ProjectMetaRow>
        <ApprovedHoursSplitRows hours={actionHours} ns={ns} t={t} />
        <ProjectMetaRow label={t(`${ns}.projectCard.actionEntries` as Parameters<typeof t>[0])}>
          {actionCount}
        </ProjectMetaRow>
      </div>
    </ApprovalConfirmCard>
  );
}
